<template>
    <v-container class="main-container">
        <message-component id="message" v-model="isMessage" :success="success">{{ message }}</message-component>
        <v-container style="margin-top: 15px;">
            <v-row>
                <v-col cols="12" xl="6" class="text-h4">ログ表示・検索</v-col>
                <v-col cols="12" xl="6" class="text-right">
                    <v-btn
                        color="light-green darken-1"
                        class="white--text"
                        v-on:click="downloadCSV"
                    >
                        CSV出力
                    </v-btn>
                </v-col>
            </v-row>
        </v-container>

        <!-- 検索エリア -->
        <v-expansion-panels>
            <v-expansion-panel>
                <v-expansion-panel-header color="#F4FEFB">
                </v-expansion-panel-header>
                <v-expansion-panel-content color="#F4FEFB">
                    <form @submit.prevent="search">
                        <v-container>
                            <v-row>
                                <v-col cols="4" xl="2">
                                    <v-text-field placeholder="会社名" v-model="searchItem.company_name" outlined clearable v-disabled-icon-focus background-color="white"></v-text-field>
                                </v-col>
                                <v-col cols="3" xl="2">
                                    <date-picker-component placeholder="日付" v-model="searchItem.start_date" outlined clearable v-disabled-icon-focus background-color="white"></date-picker-component>
                                </v-col>
                                <v-col cols="1" xl="1">
                                    
                                        <label-component>～</label-component>
                                    
                                </v-col>
                                <v-col cols="3" xl="2">
                                    <date-picker-component placeholder="日付" v-model="searchItem.end_date" outlined clearable v-disabled-icon-focus background-color="white"></date-picker-component>
                                </v-col>
                                <v-col cols="4" xl="2">
                                    <v-text-field placeholder="ユーザー名" v-model="searchItem.user_name" outlined clearable v-disabled-icon-focus background-color="white"></v-text-field>
                                </v-col>
                                <v-col cols="8" xl="2">
                                    <v-text-field placeholder="関連するログを検索" v-model="searchItem.log_message" outlined clearable v-disabled-icon-focus background-color="white"></v-text-field>
                                </v-col>
                                
                                <v-col cols="12" xl="1">
                                    <label-component>
                                        <v-btn
                                            color="light-blue darken-1"
                                            class="white--text"
                                            type="submit"
                                        >
                                            検索
                                        </v-btn>
                                    </label-component>
                                    
                                </v-col>
                            </v-row>
                        </v-container>
                    </form>
                    
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
        
        <div>
            <!-- テーブル -->
            <template>
                <v-pagination
                    v-model="indexInfo.page"
                    :length="indexInfo.pageCount"
                    class="primary"
                    
                ></v-pagination>
                <v-data-table
                    :headers="headers"
                    :items="items"
                    :page.sync="indexInfo.page"
                    :items-per-page="indexInfo.itemsPerPage"
                    @page-count="indexInfo.pageCount = $event"
                    disable-sort
                    hide-default-footer
                >
                    <template v-slot:body="props">
                        <tr v-for="(item, index) in props.items" :key="index">
                            <td class="item-td" align="center">{{ item.id }}</td>
                            <td class="item-td overtd" align="center">{{ item.company_name }}</td>
                            <td class="item-td overtd" align="center">{{ item.user_name }}</td>
                            <td class="item-td" align="center">{{ item.login_failure_datetime }}</td>
                            <td class="item-td" align="center">{{ item.log_message }}</td>
                            
                        </tr>
                    </template>
                </v-data-table>
            </template>
        </div>
    </v-container>
</template>

<script>
    import moment from "moment"
    export default {
        props: ['user'],
        data() {
            return {
                // 項目一覧
                items: [],
                // 権限
                auth: false,
                // 契約先企業
                companies: [],
                // 検索項目
                searchItem: {
                    company_name: '',
                    user_name:'',
                    start_date: '',
                    end_date: '',
                    log_message: '',
                },
                indexInfo: {
                    // ページ数
                    page: 1,
                    // 最大ページ数
                    pageCount: 0,
                    // 1ページあたりの項目数
                    itemsPerPage: 10,
                },
                // ソート、ページネーション
                options: {},
                // テーブルヘッダー
                headers: [
                  { text: 'ID', align: 'center', value: 'id' },
                  { text: '会社名', align: 'center', value: 'company_name' },
                  { text: 'ユーザー名', align: 'center', value: 'user_name' },
                  { text: '日時', align: 'center', value: 'login_failure_datetime' },
                  { text: 'メッセージ', align: 'center', value: 'log_message' },
                  { text: '', value: 'action', sortable: false },
                  { text: '', value: 'action', sortable: false },
                ],
                // メッセージ
                message: null,
                success: false,
                
           };
        },
        methods: {
            // 検索
            search() {
                axios.post('/documents/admin/search-management-log-list', this.searchItem).then((res) => {
                    this.items = res.data.items;
                    this.auth = res.data.auth;
                    this.companies = res.data.companies;
                    this.users = res.data.users;
                });
            },
            downloadCSV () {
                var csv = '\ufeff' + 'ID,会社名,ユーザー名,日時,メッセージ\n'
                this.items.forEach(el => {
                    var line = el['id'] + ',' + el['company_name'] + ',' + el['user_name'] + ',' + el['login_failure_datetime'] + ',' + el['log_message'] + '\n'
                    csv += line
                })
                let blob = new Blob([csv], { type: 'text/csv' })
                let link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                var dt = new Date();
                var csv_file_name = moment(dt).format( 'YYYYMMDDHHmmSS' )
                csv_file_name = '【管理ログ】' + csv_file_name + '.csv'
                link.download = csv_file_name
                link.click()
            },
            // エラー
            error(message) {
                this.success = false;
                this.message = message;
            }
        },
        // 初期表示のデータ
        mounted() {
            axios.get('/documents/admin/get-management-log-list').then((res) => {
                    this.items = res.data.items;
                    this.auth = res.data.auth;
                    this.companies = res.data.companies;
                    this.users = res.data.users;
                });
        },
        computed: {
            // メッセージ
            isMessage: {
                get() {
                    return this.message != null;
                },
                set(value) {
                    if (!value) {
                        this.message = null;
                    }
                }
            },
        },
        
    };
</script>

<style scoped lang="scss">
    @import '../../../sass/app.scss';
    .notice-icon {
        margin-right: 10px !important;
    }

    .main-container {
        font-family: $body-font-family;
        font-size: $font-size-root;
    }

    .main-content-area {
        margin-top: 10px;
    }

    .common-dialog-message {
        font-size: 16px !important;
        color: black !important;
    }
    ::v-deep .v-pagination__item .v-pagination__item--active .primary {
        background-color: #1976d2 !important;
        border-color: #1976d2 !important;
    }
    
    /* table */
    .v-btn:not(.v-btn--round).v-size--default {
        margin: 2px 0;
    }
    td {
        border-bottom: solid 1px rgb(0, 0, 0, 0.05);
    }
    table > th, td {
        font-size: 20px;
    }
    table{
      table-layout: fixed;
    }
    table td{
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    /* 検索エリア */
    .v-expansion-panels {
        margin: 10px 0;
    }
    .v-expansion-panel-content__wrap {
        padding-bottom: 0;
    }
</style>